module.exports = __webpack_public_path__ + "img/logo-white.39d61da9.png";